import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

import {
  Body,
  Children,
  MainHolder,
  StyledText,
} from "../../../components/common/basic";
import LiveStreamCard from "../../../components/events/livestreamCard";
import { format } from "date-fns";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

// theme
import { useTheme, useLoyalty } from "../../../hooks";
import { BackButton, FeatureHeader } from "../../../components/common";

const LiveStreamHome = () => {
  const [pastEvents, setPastEvents] = useState([]);
  const [liveEvents, setLiveEvents] = useState([]);
  const [upcomingEvents, setUpcomingEvents] = useState([]);

  const { themeContext, theme } = useTheme();
  let history = useHistory();
  const { events, eventTitle, eventText, eventBanner, setSelectedEvent } =
    useLoyalty();

  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "LiveStreamHome",
        firebase_screen_class: "LiveStreamHome",
      })
    );
  }, []);

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const handleEventClick = (item) => {
    setSelectedEvent(item);
    if (["live", "today", "past"].includes(item?.category)) {
      history.push("livestream");
    }
  };

  useEffect(() => {
    if (events) {
      setLiveEvents(
        events.filter((ev) => ev.category === "live" || ev.category === "today")
      );
      setUpcomingEvents(events.filter((ev) => ev.category === "upcoming"));
      setPastEvents(events.filter((ev) => ev.category === "past"));
    }
  }, [events]);

  return (
    <>
      <MainHolder>
        <Children>
          <BackButton
            onClick={() => {
              history.goBack();
            }}
          />
          <FeatureHeader
            image={eventBanner}
            title={[eventTitle]}
            description={eventText}
            background={"#fff"}
            secondaryBackground={"#fff"}
          />
          <Body style={{ padding: "10px 0 10px 0" }}>
            <EventSection
              title='Live/Upcoming Events'
              eventList={[...liveEvents, ...upcomingEvents]}
              section={"upcoming"}
              background={background}
              onClick={handleEventClick}
            />
            <EventSection
              title='Past Events'
              eventList={pastEvents}
              section={"past"}
              background={background}
              onClick={handleEventClick}
            />
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const EventSection = ({ title, eventList, section, background, onClick }) => (
  <div style={{ marginBottom: "20px" }}>
    <OfferHeader>
      <StyledText size={20} color={"black"} style={{ fontFamily: "MTNMedium" }}>
        {title}
      </StyledText>
      <StyledText
        size={14}
        color={background}
        style={{ fontFamily: "MTNRegular" }}
        onClick={() => {}}
      >{`View all`}</StyledText>
    </OfferHeader>
    {!eventList ||
      (eventList?.length < 1 && (
        <div
          style={{
            textAlign: "center",
            padding: "20px",
            fontFamily: "MTNRegular",
            color: "#777",
            fontSize: "12px",
          }}
        >
          {`No ${section} events are available.`}
        </div>
      ))}
    <EventContentHolder>
      <EventList>
        {eventList &&
          eventList.map((item) => {
            const { category, name, thumbnailUri, startTime } = item;
            const formattedDate = format(
              new Date(startTime),
              "eeee, MMMM do, Y"
            );
            return (
              <>
                <LiveStreamCard
                  backgroundImage={thumbnailUri}
                  location={category}
                  title={name}
                  date={formattedDate}
                  onClick={() => {
                    onClick(item);
                  }}
                />
              </>
            );
          })}
      </EventList>
    </EventContentHolder>
  </div>
);

const OfferHeader = styled.div`
  display: flex;
  box-sizing: border-box;
  padding: 0 20px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

const EventContentHolder = styled.div`
  width: 100%;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const EventList = styled.div`
  display: flex;
`;

export default LiveStreamHome;
